import IconButton from 'apollo-react/components/IconButton';
import DeleteIcon from 'apollo-react-icons/Trash';
import React from 'react';

const ActionCell = ({ row, column: { setSelectedDocuments } }) => {
  const handleDeleteRow = () => {
    setSelectedDocuments((prev) =>
      prev.filter((doc) => doc[doc.PrimaryKeyColumn] !== row[row.PrimaryKeyColumn])
    );
  };

  return (
    <IconButton onClick={handleDeleteRow}>
      <DeleteIcon />
    </IconButton>
  );
};

export default ActionCell;
